// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2fylM","header":"PatientQuestionnaire_header__2GnwD","info":"PatientQuestionnaire_info__1hUUw"};